import { useSelector } from 'react-redux';
import { Flex } from 'theme-ui';
import LoginWithEmailOtp from './EmailLogin/LoginWithEmailOtp';
import LoginWithEmailPassword from './EmailLogin/LoginWithEmailPassword';
import LoginHome from './LoginHome';
import LoginWithMobileOtp from './MobileLogin/LoginWithMobileOtp';
import ResetPassword from './ResetPassword/ResetPassword';
import { assetUrl, heroViredWebUrl } from '../../api/config';
import './login.scss';
const LoginContainer = () => {
  const { loginChildPage } = useSelector((state) => state.loginCred);

  return (
    <Flex
      p={4}
      style={{
        flexDirection: 'column',
        width: '440px'
      }}
    >
      <img
        src={`${assetUrl}/HVLogo.svg`}
        alt='hv-logo'
        width={76}
        height={18}
      />
      {loginChildPage !== 'forgotPassword' ? (
        <p
          className='login-heading'
          style={{
            marginTop: '28px',
            marginBottom: '24px'
          }}
        >
          Start Your Learning Journey
        </p>
      ) : null}
      {loginChildPage == null && <LoginHome />}
      {loginChildPage == 'mobileOTPPage' && <LoginWithMobileOtp />}
      {loginChildPage == 'emailOTPPage' && <LoginWithEmailOtp />}
      {loginChildPage == 'emailPasswordHomePage' && <LoginWithEmailPassword />}
      {loginChildPage == 'forgotPassword' && <ResetPassword />}
      <p className='privacy-note'>
        Your personal data will be used to support your experience throughout
        this website, to manage access to your account, and for other purposes
        described in our{' '}
        <a href={`${heroViredWebUrl}/privacy-policy/`}>privacy policy.</a>
      </p>
    </Flex>
  );
};

export default LoginContainer;
